module.exports = __webpack_public_path__ + "static/media/second.2d98d9de.jpeg";